import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from '../../app.service';

@Component({
  standalone: false,
  selector: 'app-hazards-account-risk-matrix',
  templateUrl: './hazards-account-risk-matrix.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./hazards-account-risk-matrix.component.scss']
})
export class HazardsAccountRiskMatrixComponent implements OnInit {
  constructor(public app: AppService) {}

  ngOnInit() {}
}
